import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getCharacterEdgeStyleMenuItems } from './lib'

/**
 * Settings subtitles character edge style menu
 */
export const SettingsSubtitlesCharacterEdgeStyleMenu =
  createSubtitlesCustomMenu(
    'SettingsSubtitlesCharacterEdgeStyleMenu',
    'character_edge_style',
    getCharacterEdgeStyleMenuItems
  )
